module.exports = __webpack_public_path__ + "img/info-and-maps.dca9c28d.png";